import { render, staticRenderFns } from "./PostsSection.vue?vue&type=template&id=145c38da&"
import script from "./PostsSection.vue?vue&type=script&lang=js&"
export * from "./PostsSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports